import React from "react";
import {FormattedMessage, useIntl} from "react-intl";
import {getMessageValue} from "@ignitesales/neuro-application/src/i18n/messageUtil";
import formatNotificationValues from "@ignitesales/neuro-application/src/validation/formatNotificationValues";
import PropTypes from "prop-types";

//TODO: this can move to Neuro. Provides generic way to render validation error messages
const ValidationMessages = ({validationErrors, render}) => {
  const intl = useIntl();

  const defaultRender = (title, errors=[], key) => {
    return <div className="validation-error-message" key={key}>
      <h1>{ title }</h1>
      { errors.map((e,i) => <span key={i}>{e}</span>) }
    </div>
  };

  return validationErrors.map(error => {
    const title = error.fieldType === 'question'
      ? <FormattedMessage id={ getMessageValue(intl.locale, `details.${ error.key }`) ? `details.${ error.key }` : error.key }/>
      : null;

    const errors = Object.keys(error.errors).map((type, index) => {
      let values = error.errors[type];
      const validationType = type === 'between' && values.length > 1 && values[0] === values[1] ? 'equal' : type;
      values = error.questionType ? formatNotificationValues(error.questionType, values) : values;
      return <FormattedMessage
        key={ `error.${ error.fieldType }.${ validationType }.${index}` }
        id={ `error.${ error.fieldType }.${ validationType }` }
        values={ { ...values } }
      />;
    });

    return render ? render({title, errors, key: error.key}) : defaultRender(title, errors, error.key);
  })
};
ValidationMessages.propTypes = {
  validationErrors: PropTypes.array.isRequired,
  render: PropTypes.func
};

export default ValidationMessages;
